module.exports = __webpack_public_path__ + "img/tarj4-1.42dbe39e.svg";